export const openBidsListParam = {
  key: 'open_bids_list',
  value: 'true',
};
